$(document).ready(function() {
  setInterval(() => {
    $('#rebuy-widget-102916.widget-type-cart.widget-layout-line .rebuy-product-grid .rebuy-product-actions').each(function(){
      let infoDiv = $(this).siblings('#rebuy-widget-102916.widget-type-cart.widget-layout-line .rebuy-product-grid .rebuy-product-info');
      $(this).appendTo(infoDiv);
    });
    $('#rebuy-cart .rebuy-cart__flyout .rebuy-cart__flyout-body .rebuy-cart__flyout-content  .rebuy-cart__flyout-items .rebuy-cart__flyout-item .rebuy-cart__flyout-item-buy-more-save-more').each(function(){
      let detail = $(this).siblings('#rebuy-cart .rebuy-cart__flyout .rebuy-cart__flyout-body .rebuy-cart__flyout-content  .rebuy-cart__flyout-items .rebuy-cart__flyout-item .rebuy-cart__flyout-item-info');
      $(this).appendTo(detail);
    });
  }, 10);
});
$(function () {
  $('.slider').slick({
    autoplay: true,
    autoplaySpeed: 0,
    speed: 2000,
    arrows: false,
    swipe: false,
    slidesToShow: 7,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        infinite: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 2.5
      }
    }
    ],
    cssEase: 'linear',
    pauseOnFocus: false,
    pauseOnHover: true,
  });
});

$(document).ready(function () {
    $('.plp-dropdown-content').on('click', function() {
        var selectedValueIdcontent = $(this).attr('data-id');
        $('#quantity-'+selectedValueIdcontent).toggleClass('active');
    });
    $('.quantity-option-sub').on('click', function() {
        var selectedValueIdcontentsub = $(this).attr('id');
        $('#'+selectedValueIdcontentsub).addClass('active');
        $(this).siblings('.quantity-option-sub').removeClass('active');
        $('.dropdown-content.active').removeClass('active');
    });
  });
